import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "aiChat__topBar" }
const _hoisted_2 = { class: "avatarWrapper" }
const _hoisted_3 = { class: "aiChat__title" }
const _hoisted_4 = { class: "betaTag" }
const _hoisted_5 = { class: "aiChat" }
const _hoisted_6 = {
  key: 0,
  class: "aiChat__main"
}
const _hoisted_7 = { class: "chatIntro" }
const _hoisted_8 = { class: "chatIntro__header" }
const _hoisted_9 = {
  key: 1,
  ref: "messagesScrollContainerRef",
  class: "aiChat__main"
}
const _hoisted_10 = {
  key: 0,
  class: "chatIntro"
}
const _hoisted_11 = { class: "chatIntro__header" }
const _hoisted_12 = {
  key: 0,
  class: "questionSuggestions"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["aria-busy"]
const _hoisted_15 = ["src"]
const _hoisted_16 = ["aria-busy"]
const _hoisted_17 = {
  key: 1,
  class: "responseLoader"
}
const _hoisted_18 = {
  key: 0,
  class: "aiChat__footer"
}
const _hoisted_19 = ["placeholder", "value", "maxlength"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuIcon = _resolveComponent("MenuIcon")!
  const _component_CloseButton = _resolveComponent("CloseButton")!
  const _component_AttensiCard = _resolveComponent("AttensiCard")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    "aria-label": "AI chat window",
    show: $props.isOpen,
    "no-padding": true,
    onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_MenuIcon, {
            type: "ai-chat",
            width: "30",
            height: "30"
          }),
          _createElementVNode("span", _hoisted_3, _toDisplayString($props.title), 1 /* TEXT */),
          _createElementVNode("span", _hoisted_4, _toDisplayString($setup.t('ai-chat.BETA_TEXT')), 1 /* TEXT */)
        ]),
        _createVNode(_component_CloseButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        })
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        (!$props.signedAiDisclaimer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_MenuIcon, { type: "sparkles" }),
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString($setup.t('ai-chat.AI_CONSENT_FORM_NOT_SIGNED_TEXT_1')) + " ", 1 /* TEXT */),
                    _cache[5] || (_cache[5] = _createElementVNode("a", {
                      href: "https://help.attensi.com/",
                      target: "_blank"
                    }, _toDisplayString('https://help.attensi.com/'), -1 /* CACHED */)),
                    _createTextVNode(" " + _toDisplayString($setup.t('ai-chat.AI_CONSENT_FORM_NOT_SIGNED_TEXT_2')), 1 /* TEXT */)
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createCommentVNode(" Chat Intro "),
              ($setup.isChatEmpty)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_MenuIcon, { type: "sparkles" }),
                      _createElementVNode("span", null, _toDisplayString($setup.t('ai-chat.INTRO_MESSAGE')), 1 /* TEXT */)
                    ]),
                    ($setup.isQuestionSuggestions)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.questionSuggestions, (suggestion, index) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: index,
                              class: "questionSuggestions__suggestion",
                              onClick: ($event: any) => ($setup.onClickSuggestion(suggestion))
                            }, _toDisplayString(suggestion), 9 /* TEXT, PROPS */, _hoisted_13))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" Messages "),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.messages, (message, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createCommentVNode(" Question "),
                  (message.messageType === 'Question')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["chatQuestion", {
                'chatQuestion--isLoading':
                  $setup.isLastMessage(index) && $props.isPendingAnswer,
              }]),
                        "aria-busy": $setup.isLastMessage(index) && $props.isPendingAnswer
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["chatQuestion__text", {
                  'chatQuestion__text--isLoading':
                    $setup.isLastMessage(index) && $props.isPendingAnswer,
                }])
                        }, _toDisplayString(message.text), 3 /* TEXT, CLASS */),
                        _createElementVNode("img", {
                          src: $props.userAvatar,
                          alt: "User Avatar",
                          height: "32",
                          width: "32"
                        }, null, 8 /* PROPS */, _hoisted_15)
                      ], 10 /* CLASS, PROPS */, _hoisted_14))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createCommentVNode(" Response "),
                        _createElementVNode("div", {
                          class: "chatResponse",
                          "aria-busy": $setup.isLastMessage(index) && $props.isPendingAnswer
                        }, [
                          _createVNode(_component_MenuIcon, {
                            type: "ai-chat",
                            width: "27",
                            height: "27"
                          }),
                          _createElementVNode("div", {
                            class: _normalizeClass(["chatResponse__text", {
                  'chatResponse__text--isError':
                    message.messageType === 'Error',
                }])
                          }, [
                            (message.messageType === 'Error')
                              ? (_openBlock(), _createBlock(_component_MenuIcon, {
                                  key: 0,
                                  type: "real-talk-purple-exclamation",
                                  class: "chatResponse__icon",
                                  color: "#C01328"
                                }))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("span", {
                              "aria-live": "polite",
                              class: _normalizeClass({
                    'chatResponse__text--isLoading':
                      $setup.isLastMessage(index) && $props.isPendingAnswer,
                  })
                            }, _toDisplayString(message.text), 3 /* TEXT, CLASS */),
                            ($setup.isLastMessage(index) && $props.isPendingAnswer)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                              : _createCommentVNode("v-if", true)
                          ], 2 /* CLASS */)
                        ], 8 /* PROPS */, _hoisted_16)
                      ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */))
      ])
    ]),
    footer: _withCtx(() => [
      ($props.signedAiDisclaimer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", {
              class: _normalizeClass(["aiChat__footer__characterCount", {
            'aiChat__footer__characterCount--isMaxLength': $setup.isQuestionMaxLength,
          }])
            }, _toDisplayString($setup.question.length) + " / " + _toDisplayString($setup.questionMaxLength), 3 /* TEXT, CLASS */),
            _createElementVNode("div", {
              class: _normalizeClass(["chatTextInput", {
            'chatTextInput--isMaxLength': $setup.isQuestionMaxLength,
          }])
            }, [
              _createElementVNode("textarea", {
                ref: "textAreaRef",
                class: "chatTextInput__input",
                placeholder: 
              $setup.t('ai-chat.MESSAGE_PLACEHOLDER', {
                maxCharacters: $setup.questionMaxLength,
              })
            ,
                value: $setup.question,
                rows: "1",
                maxlength: $setup.questionMaxLength,
                onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.handleKeyDown && $setup.handleKeyDown(...args))),
                onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.handleInput && $setup.handleInput(...args)))
              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_19),
              _createElementVNode("button", {
                type: "submit",
                class: "chatTextInput__submitButton",
                "aria-label": "submit question",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.handleSubmitQuestion && $setup.handleSubmitQuestion(...args)))
              }, [
                _createVNode(_component_MenuIcon, { type: "right-arrow" })
              ])
            ], 2 /* CLASS */),
            _createVNode(_component_AttensiCard, {
              class: "disclaimer",
              "drop-shadow": false,
              border: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("h6", null, _toDisplayString($setup.t('ai-chat.NOTICE_HEADING')), 1 /* TEXT */),
                _createElementVNode("p", null, _toDisplayString($setup.t('ai-chat.NOTICE_TEXT', { newline: '\n' })), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show"]))
}